/**
 * WooCommerce original <input> field for quantity is hidden and handled via our <select> field
 */
const CartItemQuantityField = {

  _selectors: {
    container: '.js-cart-item-quantity-custom-field',
    inputField: '.js-cart-item-quantity-input-field',
    selectField: '.js-cart-item-quantity-select-field',
  },

  init() {
    const self = this;

    this.refreshDefaultValuesOnFields();

    // Event :: changes quantity input field
    // Needs to be added to the window because when used in WooCommerce cart page,
    // the form is replaced and the event is lost.
    window.addEventListener('change', e => {
      if ( e.target.matches(self._selectors.selectField) ) {
        self.updateQuantity(e.target.value, e.target);
      }
    });

    // Event listener :: Scroll to notices
    window.jQuery(document.body).on('wc_scroll_to_notices', this.onScrollToNotices.bind(this));
  },

  /**
   * Ensures the default selected option matches the input field value
   */
  refreshDefaultValuesOnFields() {
    const self = this;

    document.querySelectorAll(this._selectors.container).forEach(node => {
      const selectField = node.querySelector(self._selectors.selectField);
      const inputField = node.querySelector(self._selectors.inputField);

      if ( inputField === null ) {
        return;
      }

      if ( parseInt(selectField.value) !== parseInt(inputField.value) ) {
        for ( let i=0; i<selectField.options.length; i++ ) {
          if ( parseInt(selectField.options[i].value) === parseInt(inputField.value) ) {
            selectField.selectedIndex = i;
            break;
          }
        }
      }
    });
  },

  updateQuantity(quantity, fieldEl) {
    const inputEl = fieldEl.closest(this._selectors.container).querySelector(this._selectors.inputField);
    inputEl.value = quantity;

    this.triggerWooCommerceCartUpdate();
  },

  triggerWooCommerceCartUpdate() {
    const updateCartBtn = document.querySelector('button[name=update_cart]');
    updateCartBtn.disabled = false;
    updateCartBtn.click();
  },

  onScrollToNotices() {
    // Scroll to top of page
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
};

export default CartItemQuantityField;